import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditRelationPage = withSuspense(lazy(() => import('./edit-relation-page')));
export default EditRelationPage;
